import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Gamepad2, Sword, Trophy, Settings } from 'lucide-react';

const Home = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900">
      <div className="container mx-auto px-4 py-16">
        <div className="text-center mb-16">
          <h1 className="text-6xl font-bold text-white mb-4" data-testid="game-title">
            Card Strategy Game
          </h1>
          <p className="text-xl text-gray-300 mb-8">
            Master the lanes, dominate your opponents
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
          <Link to="/campaign" data-testid="campaign-link">
            <Card className="hover:scale-105 transition-transform cursor-pointer h-full bg-white/10 backdrop-blur-sm border-white/20 text-white">
              <CardHeader>
                <Trophy className="h-12 w-12 mb-2 text-yellow-400" />
                <CardTitle>Campaign</CardTitle>
                <CardDescription className="text-gray-300">Battle through 30 levels</CardDescription>
              </CardHeader>
              <CardContent>
                <p className="text-sm">Face AI opponents and unlock new cards</p>
              </CardContent>
            </Card>
          </Link>

          <Link to="/multiplayer" data-testid="multiplayer-link">
            <Card className="hover:scale-105 transition-transform cursor-pointer h-full bg-white/10 backdrop-blur-sm border-white/20 text-white">
              <CardHeader>
                <Sword className="h-12 w-12 mb-2 text-red-400" />
                <CardTitle>Multiplayer</CardTitle>
                <CardDescription className="text-gray-300">Challenge other players</CardDescription>
              </CardHeader>
              <CardContent>
                <p className="text-sm">Real-time battles for glory</p>
              </CardContent>
            </Card>
          </Link>

          <Link to="/deck-builder" data-testid="deck-builder-link">
            <Card className="hover:scale-105 transition-transform cursor-pointer h-full bg-white/10 backdrop-blur-sm border-white/20 text-white">
              <CardHeader>
                <Gamepad2 className="h-12 w-12 mb-2 text-green-400" />
                <CardTitle>Deck Builder</CardTitle>
                <CardDescription className="text-gray-300">Create your strategy</CardDescription>
              </CardHeader>
              <CardContent>
                <p className="text-sm">Build the perfect 12-card deck</p>
              </CardContent>
            </Card>
          </Link>

          <Link to="/admin" data-testid="admin-link">
            <Card className="hover:scale-105 transition-transform cursor-pointer h-full bg-white/10 backdrop-blur-sm border-white/20 text-white">
              <CardHeader>
                <Settings className="h-12 w-12 mb-2 text-blue-400" />
                <CardTitle>Admin Panel</CardTitle>
                <CardDescription className="text-gray-300">Manage the game</CardDescription>
              </CardHeader>
              <CardContent>
                <p className="text-sm">Edit cards, locations, and rules</p>
              </CardContent>
            </Card>
          </Link>
        </div>

        <div className="mt-16 text-center">
          <div className="inline-block bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg p-8">
            <h2 className="text-2xl font-bold text-white mb-4">How to Play</h2>
            <div className="text-left text-gray-300 space-y-2 max-w-xl">
              <p>• Build a deck of 12 cards with costs from 0-6</p>
              <p>• Battle across 3 randomized locations with special effects</p>
              <p>• Play cards over 6 turns with increasing energy (1→6)</p>
              <p>• Win by controlling 2 out of 3 locations (or all 3)</p>
              <p>• Unlock new cards by completing campaign levels</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;